import { GamepadRoundUpIcon } from './GamepadRoundUpIcon';

/**
 * author: Haley Halcyon
 * id D3C1F57B-FF1A-4CD9-AD39-E3F3AB752779
 * name gamepad-round-up
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-round-up.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerRoundUpIcon = GamepadRoundUpIcon;
export default ControllerRoundUpIcon